export const scrollEvent = () => {
  document.addEventListener('scroll', () => {
    const element = document.querySelectorAll('.sticky-resumen')[0];
    const elmRoot = document.querySelector('#root');

    if (element !== undefined && elmRoot !== undefined) {
      if (window.scrollY <= 280) {
        element.classList.remove('active');
      } else {
        element.classList.add('active');
        element.classList.remove('sticky');
      }

      if ((window.innerHeight + window.scrollY) >= (elmRoot.offsetHeight - 720)) {
        element.classList.remove('active');
        element.classList.add('sticky');
      }
    }
  });
};

export const scrollEventMobile = () => {
  document.addEventListener('scroll', () => {
    const element = document.querySelectorAll('.sticky-resumen-mobile')[0];
    if (element !== undefined) {
      if (window.scrollY <= 110) {
        element.classList.remove('active');
      } else {
        element.classList.add('active');
      }
    }
  });
};
